import { createModule } from '@Actions/utils';
import { SERVICE_ENDPOINT } from '@Apis/constants';

const CreatePDI = createModule({
  base: 'CREATE_PDI',
  apiDetails: { ...SERVICE_ENDPOINT.PRE_DISPATCH_INSPECTION, method: 'post' },
  errors: { defaultError: true, customError: '' },
  enableNotification: true,
  customNotificationSuccessMessage: 'PDI created successfully',
});

const UpdatePDI = createModule({
  base: 'UPDATE_PDI',
  apiDetails: { ...SERVICE_ENDPOINT.PRE_DISPATCH_INSPECTION, method: 'put' },
  errors: { defaultError: true, customError: '' },
  enableNotification: true,
  customNotificationSuccessMessage: 'PDI updated successfully',
});

const GetPDI = createModule({
  base: 'GET_PDI',
  apiDetails: { ...SERVICE_ENDPOINT.PRE_DISPATCH_INSPECTION, method: 'get' },
  errors: { defaultError: true, customError: '' },
});
const GetPDIById = createModule({
  base: 'GET_PDI_BY_ID',
  apiDetails: SERVICE_ENDPOINT.PRE_DISPATCH_INSPECTION_BY_ID({}),
  errors: { defaultError: true, customError: '' },
});

const DeletePDI = createModule({
  base: 'DELETE_PDI',
  apiDetails: { ...SERVICE_ENDPOINT.PRE_DISPATCH_INSPECTION, method: 'delete' },
  errors: { defaultError: true, customError: '' },
  enableNotification: true,
  customNotificationSuccessMessage: 'PDI deleted successfully',
});

export {
  CreatePDI,
  UpdatePDI,
  GetPDI,
  DeletePDI,
  GetPDIById,
};
